@if (hasDoor() && doors?.length > 0) {
  <div class="config-container shadow mt-4">
    <h4
      (click)="toggleCollapse(SubStepEnum.Doors)"
      [ngClass]="{ active: subStep === SubStepEnum.Doors }"
      class="title configurator-subtitle collapse-button">
      <span>{{ 'fence.materials.doors' | translate }}</span>
      <span class="title-count">{{ doors?.length }} {{ 'fence.materials.available-doors' | translate }}</span>
    </h4>

    <!-- Si un portillon est désactivée et qu'aucun devis n'est valide -->
    @if (!configuration.hasValidQuotation && !isDoorsValid) {
      <span class="disabled-product pt-1 ml-4">{{ disableMessage }}</span>
    }

    <!-- Si un portillon est désactivée et que le devis est valide -->
    @if (configuration.hasValidQuotation && !isDoorsValid) {
      <span class="disabled-with-quotation-product pt-1 ml-4">{{ 'fence.materials.valid-quotation-message' | translate }}</span>
    }

    @if (subStep === SubStepEnum.Doors) {
      <div class="collapse-block">
        <div class="decoration-container">
          @for (door of doors; track door.id) {
            <div class="decoration-card">
              <div (click)="selectDoor(door)"
                   [class.active]="isDoorSelected(door)"
                   [class.disabled-card]="isDoorDisabled(door)"
                   class="posts-card">
                <img [src]="baseImgURL + door.icon" alt="door-img" class="post-img" />
              </div>

              <div class="decoration-content">
                <p class="decoration-title">{{ currentLang === 'fr' ? door.nameFr : door.nameEn }}</p>

                <div class="decoration-form-row">
                  <div class="decoration-form-group form-row">
                    <div class="form-label">
                      <label [for]="'door' + door.id + '_qty'">{{ 'fence.materials.quantity' | translate }}</label>
                    </div>
                    <div class="form-input">
                      <input
                        (change)="changeDoorQuantity(door, $event)"
                        [disabled]="!door || !door.quantity || door.quantity <= 0"
                        [id]="'door' + door.id + '_qty'"
                        [max]="maxDoor(door)"
                        [value]="door && door.quantity ? door.quantity : 0"
                        autocorrect="off"
                        min="0"
                        spellcheck="false"
                        type="number" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          } @empty {
            <ng-casto-loader></ng-casto-loader>
          }

        </div>
      </div>
    }

  </div>

}
